module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/6734251fb6ed5d15d5541891906ab891.png";